// extracted by mini-css-extract-plugin
export default {"label":"input_label__lcyKM","input":"input_input__F8KBC","disabled":"input_disabled__FM1zU"};